module.exports = __webpack_public_path__ + "static/media/ic_nav_arrow.94032e88.svg";